import { render } from "./DynamicTable.vue?vue&type=template&id=9ef17326"
import script from "./DynamicTable.vue?vue&type=script&lang=js"
export * from "./DynamicTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__